import React from 'react';
import { Box, BoxProps, withStyles } from '@material-ui/core';
import cn from 'classnames';

export const OptionWrapper = withStyles(() => ({
  root: {
    cursor: 'pointer',
  },
}))(Box);

interface DynamicLineProps extends BoxProps {
  isRight?: boolean;
  fullWidth?: boolean;
}

export const DynamicLine = withStyles(({ palette, spacing, transitions }) => ({
  root: {
    position: 'relative',
    height: 1,
    background: palette.grey[200],
    width: `100%`,
    margin: spacing(0, 0, 4),
    '&::after': {
      content: '""',
      position: 'absolute',
      top: '50%',
      left: 0,
      width: `calc(50% - ${spacing(2)}px)`,
      borderRadius: 1,
      height: 2,
      background: palette.primary.main,
      transform: `translate(0, -50%)`,
      transition: transitions.create(['transform']),
    },
    '&.right': {
      '&::after': {
        transform: `translate(calc(100% + ${spacing(4)}px), -50%)`,
      },
    },
    '&.fullWidth': {
      '&::after': {
        width: `100%`,
        transform: `translate(0, -50%)`,
      },
    },
  },
}))(({ isRight, fullWidth, ...props }: DynamicLineProps) => (
  <Box {...props} className={cn({ right: isRight, fullWidth })} />
));
